import { render } from "./Loginnav.vue?vue&type=template&id=5be6b071&scoped=true"
import script from "./Loginnav.vue?vue&type=script&lang=js"
export * from "./Loginnav.vue?vue&type=script&lang=js"

import "./Loginnav.vue?vue&type=style&index=0&id=5be6b071&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be6b071"]])

export default __exports__